import { Lesson } from '../../../../types';

const lesson: Lesson = {
  itemId: '3893603',
  title: 'Grupo de Avisos e Atualizações',
  video: { platform: 'youtube', videoId: 'kyY2WJwu1BA' },
  article: ['Descrição da aula.'],
};
export default lesson;

